export default "__VITE_ASSET__BQFUJsXa__"